import { useState } from 'react';

import { Divider, Flex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import service from '@/services/index';
import type { TOPIC_2_TYPE } from '@/types/taxonomyConst';

import S from '../styles';
import type { EditTopicModalProps } from '../types';
import UpperLevelDisplay from '../UpperLevelDisplay/UpperLevelDisplay';
import createTopicUtils from '../utils';
import RuleTopicEditItem from './RuleTopicEditItem';

const EditRuleTopic = (
  props: EditTopicModalProps & {
    initialTopic: Topic2T<TOPIC_2_TYPE.RULE>;
    closeModal: () => void;
  },
) => {
  const target: CreateTopicTarget =
    props.initialTopic.level === 1 ? 'taxonomy' : 'topic';

  const targetTopicAlias = createTopicUtils.getTargetTopicAlias(
    props.initialTopic,
  );

  const [topic, setTopic] = useState(props.initialTopic);
  const [hasChange, setHasChange] = useState(false);

  const submit = async () => {
    await service.taxonomy.updateTopicDetail(topic.alias, {
      name: topic.name,
      category: topic.category,
      filter_rule: {
        ...topic.filter_rule,
      },
    });
    props.refetch();
    props.closeModal();
  };
  return (
    <S.MainLayout style={{ width: 800 }}>
      <VFlex className="header">
        <Heading type="h2">Edit settings</Heading>
        <Typo type="body2" weight="m">
          <strong>
            Be precise and clear about what you intend to capture with the
            theme.
          </strong>
          <br />
          Syncly AI will review the data set based on the updated prompt and
          this process might take a few minutes.
        </Typo>
      </VFlex>
      <Divider />
      <VFlex className="body" g={16} style={{ overflow: 'auto' }}>
        <UpperLevelDisplay
          target={target}
          targetTopicAlias={targetTopicAlias}
          taxonomyAlias={props.taxonomyAlias}
        />
        <RuleTopicEditItem
          {...topic}
          onRuleChange={(rule) => {
            setTopic((prev) => ({
              ...prev,
              filter_rule: rule,
            }));
            setHasChange(true);
          }}
          onTitleChange={(name) => {
            setTopic((prev) => ({
              ...prev,
              name,
            }));
            setHasChange(true);
            return name;
          }}
        />
      </VFlex>
      <Divider />
      <Flex className="footer" j="flex-end">
        <Button variant="ghost" sizeType="xl" onClick={props.closeModal}>
          Cancel
        </Button>
        <Button
          variant="ghost"
          sizeType="xl"
          onClick={submit}
          disabled={!hasChange}
        >
          Done
        </Button>
      </Flex>
    </S.MainLayout>
  );
};

export default EditRuleTopic;
